import clsx from 'clsx';
import styles from './styles.module.css';

type Props = React.PropsWithChildren<{ className?: string }>;

export function ErrorMessage({ className, children }: Props) {
  if (!children) {
    return <></>;
  }
  return <p className={clsx(styles.wrapper, 'font-openSans')}>{children}</p>;
}
